export class HttpStatusCodeConstant {
    public static readonly unauthorized: number = 401;
    public static readonly badRequest: number = 400;
    public static readonly unprocessableEntity: number = 422;
    public static readonly forbidden: number = 403;
}
